import React from 'react'

export const PlacanjeNaRate = () => (
  <div className='novosti-text'>
    <p>Za više informacija pozovite +382 67 733 555.</p>
  </div>
)

